"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81744],{

/***/ 81744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98105);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14387);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87936);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34950);
/* harmony import */ var _material_ui_icons_ReportOutlined__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77217);
/* harmony import */ var react_awesome_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20890);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17812);
/* harmony import */ var components_UserPhoto__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64410);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79794);
/* harmony import */ var components_modal_ReportModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49957);
/* harmony import */ var components_UserName__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37915);
/** @format */ 








// import { useRouter } from "next/router";


// import commentLikeFunction from "firestore/commentLikeFunction";




// import { HistoryStorageUrl } from "components/HistoryStorageUrl";




var AppDetailComments = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__/* .observer */ .Pi)(function(param) {
    var email = param.email, appId = param.appId, appName = param.appName;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), reviewDatas = ref[0], setReviewDatas = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var collectionRef, collectionValue, tempReviewDatas, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!settings.email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    collectionRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("gcf").doc(email).collection("app").doc(appId).collection("review");
                    return [
                        4,
                        collectionRef.orderBy("createdAt", "desc").get()
                    ];
                case 2:
                    collectionValue = _state.sent();
                    tempReviewDatas = [];
                    collectionValue.forEach(function(doc) {
                        if (doc.data().visible) {
                            tempReviewDatas.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, doc.data()), {
                                id: doc.id
                            }));
                        }
                    });
                    setReviewDatas(tempReviewDatas);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "aiso_detail_footer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OverviewConmmentsInput, {
                reviewDatas: reviewDatas,
                email: email,
                appName: appName
            }),
            reviewDatas && reviewDatas.length > 0 ? reviewDatas.slice(0, 2).map(function(m) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(ReviewRow, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, m), {
                    key: m.id,
                    appEmail: email
                }));
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-base flex justify-center py-5",
                children: "등록된 후기가 없습니다."
            })
        ]
    });
});
var OverviewConmmentsInput = function(param) {
    var reviewDatas = param.reviewDatas, email = param.email, appName = param.appName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible = ref[0], setModalVisible = ref[1];
    var closeModal = function() {
        setModalVisible(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full border-b-2 border-white py-2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex justify-between items-center px-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mb-0 text-sm pr-3 font-gmarket-medium",
                            children: [
                                "사용 후기 ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "ml-1 font-bold",
                                    children: "".concat(reviewDatas.length, "건")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "btn glass_in_box_btn p-2 text-sm",
                            onClick: function() {
                                return setModalVisible(true);
                            },
                            children: "전체 보기"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentsModal, {
                            modalVisible: modalVisible,
                            closeModal: closeModal,
                            reviewDatas: reviewDatas,
                            appEmail: email,
                            appName: appName
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Toggle */ .Z.Toggle, {
                            variant: "",
                            id: "dropdownMenuOutlineButton4",
                            className: "no-arrow-dropdown btn glass_in_box_btn p-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "mdi mdi-filter-variant mr-1"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-sm",
                                    children: "정렬"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Menu */ .Z.Menu, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa fa-heart-o mr-3"
                                        }),
                                        "인기순"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa fa-sort-amount-asc mr-3"
                                        }),
                                        "오래된 날짜순"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa fa-sort-amount-desc mr-3"
                                        }),
                                        "최근 날짜순"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var CommentsModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, appEmail = param.appEmail, reviewDatas = param.reviewDatas, appName = param.appName;
    // const styles = useStyles();
    return(// <Modal visible={modalVisible} width="520" height="720" effect="fadeInUp" onClickAway={() => closeModal()}>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        visible: modalVisible,
        width: "520",
        height: "720",
        effect: "fadeInUp",
        onClickAway: function() {
            return closeModal();
        },
        className: "rounded-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "aiso-modal rounded-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "aiso-modal-header w-full justify-content-between border-b",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-start py-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-base font-bold text-333 mb-0 mr-3",
                                    children: appName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "btn btn-text-grayPrimary p-3",
                            onClick: function() {
                                return closeModal();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "ti-close font-bold"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full border-b border-ddd py-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between items-center px-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "mb-0 text-gray text-xs pr-2",
                                    children: [
                                        "전체 후기 ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-1 font-black text-primary",
                                            children: "".concat(reviewDatas.length, " 건")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Toggle */ .Z.Toggle, {
                                        variant: "",
                                        id: "dropdownMenuOutlineButton4",
                                        className: "no-arrow-dropdown btn btn-white2 py-2 px-3 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "mdi mdi-filter-variant mr-1"
                                            }),
                                            " 정렬"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Menu */ .Z.Menu, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "fa fa-heart-o mr-3"
                                                    }),
                                                    "인기순"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "fa fa-sort-amount-asc mr-3"
                                                    }),
                                                    "오래된 날짜순"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "fa fa-sort-amount-desc mr-3"
                                                    }),
                                                    "최근 날짜순"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "aiso-modal-body",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full overflow-y-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                height: "560px"
                            },
                            children: reviewDatas && reviewDatas.length > 0 ? reviewDatas.map(function(m) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewRow, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, m), {
                                    appEmail: appEmail
                                }), m.id);
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-base text-aaa flex justify-center py-5 font-gmarket-medium",
                                children: "등록된 후기가 없습니다."
                            })
                        })
                    })
                })
            ]
        })
    }));
};
var ReviewRow = function(param) {
    var id = param.id, appId = param.appId, appName = param.appName, appEmail = param.appEmail, email = param.email, userName = param.userName, review = param.review, comment = param.comment, commentedAt = param.commentedAt, createdAt = param.createdAt;
    var photoUrl = (0,components_UserPhoto__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(email);
    var photoUrl2 = (0,components_UserPhoto__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(appEmail);
    var name = (0,components_UserName__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(email);
    // const { historyInputFile, historyOutputFile } = HistoryStorageUrl(inputFile, outputFile);
    // const settings = useSettings();
    // const [commentLike, setCommentLike] = useState(0);
    // const [commentLikeCheck, setCommentLikeCheck] = useState();
    /* 신고 Modal  */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), reportModalVisible = ref[0], setReportModalVisible = ref[1];
    // useEffect(async () => {
    //   if (settings.email) {
    //     try {
    //       const collectionRef = projectFirestore
    //         .collection("gcf")
    //         .doc(email)
    //         .collection("app")
    //         .doc(appId)
    //         .collection("review")
    //         .doc(id)
    //         .collection("like");
    //       const datas = [];
    //       const collectionValue = await collectionRef.get();
    //       collectionValue.forEach((doc) => {
    //         datas.push({ ...doc.data() });
    //         if (doc.id === settings.email) {
    //           setCommentLikeCheck(doc.data().createdAt);
    //         }
    //       });
    //       setCommentLike(datas.length);
    //     } catch (error) {
    //       console.error(error);
    //     }
    //   }
    // }, []);
    /* 댓글 좋아요 클릭 */ // const handleCommentLikeClick = async () => {
    //   /**
    //    * 댓글 좋아요 누르면 바로 저장 & 삭제
    //    * id, appId, userEmail, appEmail, settingsEmail,
    //    * commentLike, setCommentLike, commentLikeCheck, setCommentLikeCheck
    //    */
    //   const { tempCommentLike, tempCommentLikeCheck } = await commentLikeFunction(
    //     id,
    //     appId,
    //     email,
    //     appEmail,
    //     settings.email,
    //     commentLike,
    //     commentLikeCheck
    //   );
    //   setCommentLikeCheck(tempCommentLikeCheck);
    //   setCommentLike(tempCommentLike);
    // };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-3 px-md-3 py-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "border-b border-gray-300",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-start items-center w-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "img-cover-box w-7 h-7 sm:w-10 sm:h-10",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "rounded-full border",
                                                src: photoUrl
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "whitespace-pre-line break-all ml-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "truncate-1-lines font-bold text-base",
                                            children: name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                color: "black",
                                onClick: function() {
                                    return setReportModalVisible(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ReportOutlined__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full pb-3 px-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mt-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mb-0 text-base",
                                                children: review
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mb-0 text-555 mt-1 text-sm flex justify-start",
                                                children: createdAt ? createdAt.substring(0, 10) : ""
                                            })
                                        ]
                                    })
                                }),
                                commentedAt === "" ? "" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full mt-4 border-t pt-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs text-primary font-bold mb-3",
                                            children: "답글"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "img-cover-box w-8 h-8",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            className: "rounded-full border",
                                                            src: photoUrl2
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "ml-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "#",
                                                        className: "font-bold text-333 text-base",
                                                        children: userName
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full mt-2 pb-3 px-5",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "w-full mb-0 text-333 text-base break-words",
                                                    children: comment
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mb-0 text-888 mt-3",
                                                    children: createdAt
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReportModalContent, {
                reportModalVisible: reportModalVisible,
                closeModal: function() {
                    return setReportModalVisible(false);
                },
                id: id,
                appId: appId,
                appName: appName,
                appEmail: appEmail
            })
        ]
    });
};
// 신고 모달
var ReportModalContent = function(param) {
    var reportModalVisible = param.reportModalVisible, closeModal = param.closeModal, id = param.id, appId = param.appId, appName = param.appName, appEmail = param.appEmail;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), title = ref[0], setTitle = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), content = ref1[0], setContent = ref1[1];
    var handleModalOkButton = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var date, createdAt, text, text1, collectionRefAppUser, values, _tmp, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = new Date();
                        createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_17__/* .FormatDate */ .r2)(date);
                        if (title === "") {
                            text = "신고 제목을 입력해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text);
                            return [
                                2
                            ];
                        }
                        if (content === "") {
                            text1 = "신고 내용을 입력해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text1);
                            return [
                                2
                            ];
                        }
                        closeModal();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("gcf").doc(appEmail).collection("reviewReport")
                        ];
                    case 2:
                        collectionRefAppUser = _state.sent();
                        _tmp = {};
                        values = (_tmp.email = settings.email, _tmp.userName = settings.name, _tmp.reviewId = id, _tmp.appId = appId, _tmp.appName = appName, _tmp.appEmail = appEmail, _tmp.title = title, _tmp.content = content, _tmp.createdAt = createdAt, _tmp.status = "미확인", _tmp);
                        return [
                            4,
                            collectionRefAppUser.add(values)
                        ];
                    case 3:
                        _state.sent();
                        setTitle("");
                        setContent("");
                        closeModal();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("신고내용이 등록되었습니다.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("신고 등록 실패");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ReportModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        modalVisible: reportModalVisible,
        closeModal: closeModal,
        handleModalOkButton: handleModalOkButton,
        title: title,
        setTitle: setTitle,
        content: content,
        setContent: setContent
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppDetailComments);


/***/ })

}]);